export const TRACKS_MAPPING = 'TRACKS_MAPPING';
export const DELETE = 'DELETE';
export const SORT = 'SORT';
export const MORE = 'MORE';
export const LOADING = 'LOADING';
export const TOTAL = 'TOTAL';
export const RESET = 'RESET';
export const RESET_MODAL = 'RESET_MODAL';
export const SET_CANONICAL_POINTS = 'SET_CANONICAL_POINTS';
export const SET_FILTERES = 'SET_FILTERES';
export const SET_JERSEYS_OVERVIEW = 'SET_JERSEYS_OVERVIEW';
export const SET_MODAL = 'SET_MODAL';
export const SET_TABLE_MODE = 'SET_TABLE_MODE';

export default {
  TRACKS_MAPPING,
  SORT,
  DELETE,
  MORE,
  LOADING,
  TOTAL,
  RESET,
  RESET_MODAL,
  SET_CANONICAL_POINTS,
  SET_FILTERES,
  SET_JERSEYS_OVERVIEW,
  SET_MODAL,
  SET_TABLE_MODE,
};
